import React from "react";
import { Seo } from "@/components/Seo";
import { CtaBand } from "@/components/PageBits";
import { useLead } from "@/context/LeadContext";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { Testimonials } from "@/components/landing/Testimonials";
import { AnimatedLines } from "@/components/landing/AnimatedLines";

export default function Realisations() {
  const { openForm } = useLead();
  return (
    <div data-testid="realisations-page">
      <Seo
        title="Réalisations Avant / Après — Auto & Habitat | MARTIN NETTOYAGE"
        description="Découvrez nos résultats avant/après : detailing auto, façades, terrasses, allées. Preuves concrètes à Belfort, Montbéliard, Héricourt."
        path="/realisations"
      />
      <section className="relative overflow-hidden bg-background border-b border-border">
        <AnimatedLines />
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 py-14 text-center">
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink">
            Nos réalisations Avant / Après
          </h1>
          <p className="text-muted-foreground mt-4 text-base sm:text-lg max-w-2xl mx-auto">
            La preuve par l'image : glissez le curseur pour révéler la transformation.
          </p>
        </div>
      </section>
      <BeforeAfter />
      <Testimonials />
      <CtaBand onReserve={() => openForm("auto")} title="Envie du même résultat ?" subtitle="Estimez votre projet en quelques clics." />
    </div>
  );
}
